import { Controller } from "stimulus";

const CLASS_OPENED = 'is-dropdown-opened';

export default class extends Controller {
    toggle() {
        this.element.classList.toggle(CLASS_OPENED);
    }
}
